import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  gs,
  a,
  BoxC,
  BtnC,
  GridC,
  MsgC,
  TextC,
  _cv_31___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as MsgC from "./_cccMsgC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hfDTM from './_hfDTM';

import * as icvI1zD10To1 from './icvI1zD10To1';

export const O = (pz: {
  sPz: ht.dz,
  cz: {
    _31rs?: ht.ls,
  }
}) => {

  const _gStgz = gs.useStgz();
  const _gUserz = gs.useUserz();

  //hf.l(`icvI1zD10To 32:${hf.s(_gStgz.crt)}`)
  return (

    cr.c(BoxC.N, {
      key: -10,
      abtType: 'baseAreaz',
      oClds: [

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'msgAreaz',
          boxStlz: a(`bc/lt9 bs/ds bwb/1 pb/2`),
          oClds: [

            pz.sPz.crt.ctt == 'e' ? // エントリーの場合のみ
            cr.c(GridC.N, {
              key: -20,
              abtType: 'brdMsgz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [

                        cr.c(TextC.N, {
                          key: -20,
                          textz: {
                            pfx: `【抽選が終わり、当選した予約のキャンセルは、予約画面から行って下さい】`,
                            stlz: a('tb tc/lt9 ts/m ta/c'),
                          },
                        })

                      ]
                    }
                  ]
                }
              ]
            })
            : undefined,

            cr.c(GridC.N, {
              key: -10,
              abtType: 'brdMsgz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [

                        cr.c(TextC.N, {
                          key: -10,
                          textz: {
                            pfx: `★新たに${pz.sPz.crt.dffz.tgt}をする場合は、対象施設の「新規${pz.sPz.crt.dffz.tgt}」ボタンを押してください。`,
                            stlz: a('tb tc/rd5 ts/m'),
                          },
                        }),

                      ]
                    }
                  ]
                }
              ]
            })

          ]
        }),

        cr.c(BoxC.N, {
          key: -10,
          abtType: 'topAreaz',
          oClds: [

            cr.c(GridC.N, {
              key: -10,
              abtType: 'brdAltz',
              boxStlz: a('dw/40 mb/1'),
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          textz: {
                            pfx:
                              pz.sPz.crt.ctt == 'r' ?
                                `受付中の予約`
                              : pz.sPz.crt.ctt == 'e' ?
                                _gStgz.crt.alyMsg0
                              : '',
                            stlz: a('tb tc/lt1 ts/l'),
                          },
                        })
                      ]
                    }
                  ]
                },
                {
                  cellCs: [
                    {
                      boxStlz: a('dw/f'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          boxStlz: a('dw/f fd/ccc pv/1 sc/lt1'),
                          textz: {
                            pfx: 
                              pz.sPz.crt.ctt == 'r' ?
                                `${_gStgz.crt.rsvEndDate ?? ''}利用予約分まで`
                              : pz.sPz.crt.ctt == 'e' && _gUserz.crt.i19rz?.i19ra4100i == 3 ?
                                `${hfDTM.f(_gStgz.crt.tgtSttDate, '年月', false)}〜${hfDTM.cvtMth(_gStgz.crt.tgtEndDate)}月 利用予約分`
                              : pz.sPz.crt.ctt == 'e' ?
                                `${hfDTM.f(_gStgz.crt.alyMth + '-01', '年月', false)} 利用予約分`
                              : ``,
                            stlz: a('tb tc/rd5 ts/m'),
                          },
                        }),
                      ]
                    }
                  ]
                }
              ]
            }),

            pz.sPz.crt.ctt == 'e' ?
            cr.c(TextC.N, {
              key: -15,
              boxStlz: a('dw/f fd/ccc sc/lt1'),
              textz: {
                pfx: `［受付期間］${hfDTM.f(_gStgz.crt.alySttDate ?? hfDTM.getTdy(), '年月日', false)}〜${hfDTM.f(_gStgz.crt.alyEndDate ?? hfDTM.getTdy(), '月日', false)}`,
                stlz: a('tb tc/rd5 ts/m'),
              },
            })
            : undefined,

            pz.sPz.crt.ctt == 'r' ?
            cr.c(GridC.N, {
              key: -20,
              abtType: 'brdMsgz',
              boxStlz: 
                cr.chkDvc() == 'p' ?
                  a('dw/100')
                : a('dw/f'),
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          textz: {
                            pfx: '注意事項',
                            stlz: a('tb tc/rd5'),
                          }
                        })
                      ]
                    }
                  ]
                },
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(MsgC.N, {
                          key: -10,
                          abtType: 'wrn1z',
                          cz: {
                            ls: [
                              {
                                mkrCz: {
                                  textz: {
                                    pfx: '・',
                                  }
                                },
                                msgCz: {
                                  textz: {
                                    pfx: '使用日の1週間前を過ぎるとwebでのキャンセル・変更はできません。',
                                  }
                                },
                              },
                              {
                                mkrCz: {
                                  textz: {
                                    pfx: '・',
                                  }
                                },
                                msgCz: {
                                  textz: {
                                    pfx: '料金は当日入室前までにお支払いください。',
                                  }
                                },
                              },
                              {
                                mkrCz: {
                                  textz: {
                                    pfx: '・',
                                  }
                                },
                                msgCz: {
                                  textz: {
                                    pfx: 'お支払い済みの予約をキャンセルする場合は、電話か、直接窓口にお越しください。',
                                  }
                                },
                              },
                            ],
                          },
                        }),
                      ]
                    }
                  ]
                }
              ]
            })
            : null,

          ],
        }),

        cr.c(icvI1zD10To1.O, {
          key: -30,
          sPz: pz.sPz,
          cz: {
            _31rs: pz.cz?._31rs,
          }
        }),

        cr.c(BoxC.N, {
          key: -40,
          abtType: 'btnAreaz',
          oClds: [

            cr.c(BtnC.N, {
              key: -10,
              abtType: 'backCmnz',
              boxStlz: a('mb/2'),
              lblCz: {
                textz: {
                  pfx: `前の画面に戻る`,
                },
              },
              pslPtyz: {
                onPress: () => {
                  cr.moveTo({
                    pageName: 'icvHomeD10Rz',
                  });
                },
              },
            })

          ],
        })

      ],
    })


  );
};
